import SettingsIcon from "@material-ui/icons/Settings";

import { TerminalSettingPerDateList } from "./List/List";
import { TerminalSettingPerDateCreate } from "./Create/Create";
import { TerminalSettingPerDateEdit } from "./Edit/Edit";

export const terminalSettingPerDateResource = {
	list: TerminalSettingPerDateList,
	create: TerminalSettingPerDateCreate,
	edit: TerminalSettingPerDateEdit,
	icon: SettingsIcon,
};
